import { render, staticRenderFns } from "./shop-detail.vue?vue&type=template&id=76efa65c"
import script from "./shop-detail.vue?vue&type=script&lang=js"
export * from "./shop-detail.vue?vue&type=script&lang=js"
import style0 from "./shop-detail.vue?vue&type=style&index=0&id=76efa65c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports